import { render, staticRenderFns } from "./BaseLoadingDialog.vue?vue&type=template&id=63fb8076"
import script from "./BaseLoadingDialog.vue?vue&type=script&lang=js"
export * from "./BaseLoadingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports